import {Component, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {Location} from '@angular/common';
import {AlertService, CallCenterActionService, WidgetService} from '../_services';
import {CallCenterAction, getFunnelPathVariables, WidgetVariable} from '../_models';
import {CrudListComponent} from '../_directives';
import {Observable} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {NgxSmartModalService} from 'ngx-smart-modal';

@Component({
  moduleId: module.id.toString(),
  templateUrl: './call-center-action.component.html'
})
export class CallCenterActionComponent extends CrudListComponent implements OnInit {
  actions$: Observable<CallCenterAction[]> = this.data$;
  selectedAction: CallCenterAction;
  contentVariables = null;

  constructor(
    protected router: Router,
    protected location: Location,
    protected route: ActivatedRoute,
    protected actionService: CallCenterActionService,
    protected alertService: AlertService,
    private modalService: NgxSmartModalService,
    private widgetService: WidgetService
  ) {
    super(router, location, route, actionService, alertService);
    this.objectName = 'call center action';
    this.title = 'Call Center Actions';
  }

  ngOnInit() {
    super.ngOnInit();

    //get the content variables once, rather than every time the popup opens
    this.widgetService.getVariables()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (widgets: WidgetVariable[]) => {
          let items = [{value: '{support_phone}', text: 'Call Center Phone'}].concat(getFunnelPathVariables());

          widgets.forEach((widget: WidgetVariable) => {
            items.push({value: '{' + widget.slug + '}', text: widget.name});
          });

          items.sort((a, b): number => {
            if (a.text < b.text) return -1;
            if (a.text > b.text) return 1;
            return 0;
          });

          this.contentVariables = items;
        },
        error => {
          this.handleError(error);
        }
      );
  }

  create() {
    this.selectedAction = {
      id: null,
      name: null
    } as CallCenterAction;
    this.openEditDialog();
  }

  edit(action: CallCenterAction) {
    this.selectedAction = action;
    this.openEditDialog();
  }

  protected openEditDialog() {
    this.modalService.getModal('callCenterActionDialog').open();
  }

  onSaveAction(action: CallCenterAction) {
    this.modalService.getModal('callCenterActionDialog').close();
    this.queryData();
  }
}
